import clsx from 'clsx';
import { CloudUpload } from 'lucide-react';

/** t187u: a clock punch saved on this device, not yet on the server. */
export function WaitingMarker({ className, short }: { className?: string; short?: boolean }) {
  return (
    <span className={clsx('inline-flex items-center gap-1 text-xs font-medium text-slate-600 dark:text-slate-300', className)} data-testid="clock-waiting" title="Waiting to send">
      <CloudUpload className="h-3.5 w-3.5 shrink-0" aria-hidden />{short ? 'Waiting' : 'Waiting to send'}
    </span>
  );
}
